<template>
  <v-main>
    <router-view />
    <FloatVideo></FloatVideo>
  </v-main>
</template>

<script>
import FloatVideo from "@/modules/consultation/FloatVideo.vue";
export default {
  name: "CoreView",

  components: { FloatVideo },
};
</script>
